import { i18n } from '../../../shared/i18n/i18n.js'

import { useMobileNavDestinations } from '../hooks/useMobileNavDestinations.js'
import {
  MOBILE_DESTINATION_ID,
} from '../utils/mobileNavDestinations.js'

import { Button } from '../../../shared/ui/Button/Button.jsx'
import {
  Gallery,
  Heart,
  Plan,
  Tiers,
  ThreeDModel,
  ViewList,
} from '../../../shared/ui/icons/index.js'


import styles from './MobileNavBar.module.scss'

function getLabel(key, fallback) {
  const resolved = i18n.t(key)
  return resolved === key ? fallback : resolved
}

const DESTINATION_META = {
  [MOBILE_DESTINATION_ID.VISUALIZATION]: {
    icon: Gallery,
    label: () => getLabel('hero.tab_visualization', 'Visualization'),
  },
  [MOBILE_DESTINATION_ID.MODEL]: {
    icon: ThreeDModel,
    label: () => getLabel('hero.open_three_d_model', '3D Model'),
  },
  [MOBILE_DESTINATION_ID.TIERS]: {
    icon: Tiers,
    label: () => getLabel('catalog.tiers', 'Tiers'),
  },
  [MOBILE_DESTINATION_ID.PRODUCT]: {
    icon: Plan,
    label: () => getLabel('catalog.view_floor_plan', 'Plan'),
  },
  [MOBILE_DESTINATION_ID.CATALOG]: {
    icon: ViewList,
    label: () => getLabel('catalog.header_default', 'Catalog'),
  },
  [MOBILE_DESTINATION_ID.FAVORITES]: {
    icon: Heart,
    label: () => getLabel('catalog.favorites', 'Favorites'),
  },
}

export function MobileNavBar() {
  const {
    destinations,
    activeDestinationId,
    navigateToDestination,
  } = useMobileNavDestinations()

  if (!Array.isArray(destinations) || destinations.length === 0) return null

  return (
    <div className={styles.mobileNavBarBox} aria-hidden="true">
      <nav className={styles.mobileNavBar} aria-label={getLabel('common.navigation', 'Mobile navigation')}>
        {destinations.map((destination) => {
          const meta = DESTINATION_META[destination.id]
          if (!meta) return null

          const Icon = meta.icon
          const isActive = destination.id === activeDestinationId

          return (
            <Button
              key={destination.id}
              kind="text"
              size="large"
              variant={isActive ? 'default' : 'ghost'}
              selected={isActive}
              className={styles.navButton}
              aria-pressed={isActive}
              onClick={() => navigateToDestination(destination.id)}
            >
              <Icon 
                className={styles.icon} 
                inverseColor={isActive ? 'var(--bim-color-secondary)' : 'var(--bim-color-surface-lightest)'}
                />
              {/* <span className={styles.label}>{meta.label()}</span> */}
            </Button>
          )
        })}
      </nav>
    </div>
  )
}
